export const SELLER_QUICKVIEW_URLS = [
  'search',
  'did-you-forget',
  'order',
  'lists',
  'all-available-deals',
];
